export default {"src":"/_next/static/media/letterB.9723fc24.svg","height":73,"width":64,"blurWidth":0,"blurHeight":0};